import PropTypes from 'prop-types';
import HspDropdown from '../../Dropdowns/HspDropdown/HspDropdown';
import {getDisplayValue} from './chooseTubingUtils';

/**
 * Stateless dropdown for tubing color selection.
 */
function ColorDropdown({
  choices,
  design,
  isCompatible,
  heatshrinkCompatibility,
  lastSelected,
  compatibilityLookup,
  onSelect: _onSelect,
  util
}) {
  return (
    <HspDropdown
      label={{labelContent: 'Tubing Color', labelKey: 'color'}}
      topLevelClassNames={
        !isCompatible &&
        heatshrinkCompatibility?.safestActions?.includes('heatshrinkColor') &&
        lastSelected !== 'heatshrinkColor'
          ? 'has-error'
          : ''
      }
      dropdownMenuItems={choices}
      dropdownToggleItems={{
        isDropdownActive: false,
        dropdownText: getDisplayValue('heatshrinkColor', design.heatshrinkColor, util),
        dropdownClasses:
          !compatibilityLookup['heatshrinkColor'] && lastSelected !== 'heatshrinkColor'
            ? 'not-compatible'
            : ''
      }}
      includeSwatch={true}
    />
  );
}

ColorDropdown.propTypes = {
  choices: PropTypes.array.isRequired,
  design: PropTypes.object.isRequired,
  isCompatible: PropTypes.bool.isRequired,
  heatshrinkCompatibility: PropTypes.object,
  lastSelected: PropTypes.string.isRequired,
  compatibilityLookup: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  util: PropTypes.object.isRequired
};

export default ColorDropdown;
